import { jsxs as f, jsx as r } from "react/jsx-runtime";
import { forwardRef as c } from "react";
const h = ({
  title: i,
  titleId: l,
  ...a
}, e) => /* @__PURE__ */ f("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ref: e, "aria-labelledby": l, ...a, children: [
  i ? /* @__PURE__ */ r("title", { id: l, children: i }) : null,
  /* @__PURE__ */ r("rect", { width: 24, height: 24, fill: "#fff", rx: 12 }),
  /* @__PURE__ */ r("path", { fill: "#00f", d: "M18 6.948c0-.325 0-.487-.061-.612a.6.6 0 0 0-.275-.275C17.54 6 17.377 6 17.052 6H6.948c-.324 0-.487 0-.612.061a.6.6 0 0 0-.275.275c-.06.125-.06.287-.06.612v10.104c0 .325 0 .487.06.612.06.12.156.216.275.275.125.061.288.061.612.061h10.104c.325 0 .487 0 .612-.061a.6.6 0 0 0 .275-.275c.061-.125.061-.287.061-.612z" })
] }), s = c(h);
export {
  s as default
};
//# sourceMappingURL=base.js.map
